interface ReferralSearchParams {
	int_id: "dealer_cta_referral_link" | "dealer_open_listing_referral_link" | "dealer_share_vehicles_link"
	mediaCenter?: boolean
	referral: string
}

export const addReferralToUrl = (baseUrl: string, params: ReferralSearchParams): string => {
	const { int_id, mediaCenter, referral } = params
	const url = new URL(baseUrl)
	url.searchParams.set("referral", referral)
	url.searchParams.set("int_id", int_id)
	if (mediaCenter) {
		url.searchParams.set("mediaCenter", "true")
	}
	return url.toString()
}
